export default __webpack_public_path__ + "static/media/058-sd card.ade87ace.svg";